export default Object.freeze({
  OneTime: 1,
  Recurring: 2,
});
